import { Copy, Check, MessageCircle, Share2 } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";
import { CarregandoBloco } from "@/components/carregando";

export default function CodigoIndicacao({ code, link, mesesPorIndicacao, loading }) {
  const [copiado, setCopiado] = useState("");

  const copiar = async (texto, qual) => {
    try {
      await navigator.clipboard.writeText(texto);
      setCopiado(qual);
      toast.success(qual === "code" ? "Código copiado!" : "Link copiado!");
      setTimeout(() => setCopiado(""), 2000);
    } catch {
      // clipboard bloqueado (http, permissao negada): o texto esta' na tela,
      // entao avisa em vez de falhar em silencio.
      toast.error("Não consegui copiar — selecione e copie manualmente.");
    }
  };

  const compartilharWhats = () => {
    const texto =
      `Uso o Núcleo pra gerenciar meu estabelecimento e recomendo. ` +
      `Cadastre-se pelo meu link: ${link}
` +
      `Antes de pagar a primeira mensalidade, informe meu código ${code} em Assinatura.`;
    window.open(`https://wa.me/?text=${encodeURIComponent(texto)}`, "_blank");
  };

  if (loading) return <CarregandoBloco altura="h-[257px]" />;

  return (
    <div className="rounded-2xl border bg-card p-6">
      <div className="flex items-center gap-2 mb-1">
        <Share2 className="w-4 h-4 text-primary" />
        <h2 className="font-semibold">Seu código de indicação</h2>
      </div>
      <p className="text-sm text-muted-foreground mb-5">
        A loja indicada informa este código em <strong className="text-foreground">Assinatura</strong>; quando ela pagar a primeira mensalidade, você ganha{" "}
        <strong className="text-foreground">
          {mesesPorIndicacao} meses grátis
        </strong>
        .
      </p>

      <div className="flex flex-col sm:flex-row gap-3">
        <div className="flex-1 rounded-xl border-2 border-dashed border-primary/40 bg-primary/5 px-4 py-3 text-center">
          <p className="text-[10px] uppercase tracking-wider text-muted-foreground font-bold mb-1">
            Código
          </p>
          <p className="text-2xl font-black tracking-[0.2em] text-primary break-all">
            {code || "—"}
          </p>
        </div>
        <div className="flex sm:flex-col gap-2">
          <Button
            variant="outline"
            className="flex-1 sm:flex-none"
            onClick={() => copiar(code, "code")}
            disabled={!code}
          >
            {copiado === "code" ? (
              <Check className="w-4 h-4 mr-2" />
            ) : (
              <Copy className="w-4 h-4 mr-2" />
            )}
            Copiar código
          </Button>
          <Button
            className="flex-1 sm:flex-none"
            onClick={compartilharWhats}
            disabled={!link}
          >
            <MessageCircle className="w-4 h-4 mr-2" />
            WhatsApp
          </Button>
        </div>
      </div>

      <LinhaDoLink link={link} copiado={copiado === "link"} onCopiar={() => copiar(link, "link")} />
    </div>
  );
}

function LinhaDoLink({ link, copiado, onCopiar }) {
  return (
    <div className="mt-3 flex items-center gap-2 rounded-lg bg-muted/50 px-3 py-2">
      <p className="flex-1 text-xs font-mono text-muted-foreground truncate">
        {link || "—"}
      </p>
      <Button size="sm" variant="ghost" onClick={onCopiar} disabled={!link}>
        {copiado ? <Check className="w-3.5 h-3.5" /> : <Copy className="w-3.5 h-3.5" />}
      </Button>
    </div>
  );
}
